import { INSTALLMENT_TYPES } from 'constants/agreement/installmentTypes';
import { getOnlyNumbers } from './currency';
import { PENALTY_KINDS } from 'constants/agreement/penaltyKinds';
import { toast } from 'react-toastify';

const parcelsHoursSum = parcels => {
  const hours = parcels.map(parcel => parseInt(parcel.hours));
  const total = hours.reduce((accumulator, value) => accumulator + value, 0);
  return total;
};

const parcelsAmountSum = parcels => {
  const amount = parcels.map(parcel => parseInt(parcel.amount));
  const total = amount.reduce((accumulator, value) => accumulator + value, 0);
  return total;
};

const orderParcelsByInitialDate = parcels => {
  return parcels.sort((a, b) => Date.parse(a.initialDate) - Date.parse(b.initialDate));
};

const parcelsSum = parcels => {
  const numbers = parcels.map(parcel => parseInt(getOnlyNumbers(parcel.value)));
  const total = numbers.reduce((accumulator, value) => accumulator + value, 0);
  return total / 100;
};

const parcelsIntegerSum = parcels => {
  const parcelsInt = parcels.map(parcel => parseInt(parcel.value));
  const total = parcelsInt.reduce((accumulator, value) => accumulator + value, 0);
  return total;
};

const paidValue = (parcel, installmentType, context) => {
  return INSTALLMENT_TYPES[context].PAID_BY_SPECIFIC_DATE === installmentType
    ? parseInt(parcel.partiallyPaidValue) || (parcel.wasPaid ? parseInt(parcel.value) : 0)
    : INSTALLMENT_TYPES[context].VARIABLE_PER_PERIOD === installmentType
    ? parseInt(parcel.partiallyPaidValue) || 0
    : parcel.wasPaid && !parcel.paymentsHistory?.length
    ? parseInt(parcel?.value)
    : parseInt(parcel.partiallyPaidValue) || 0;
};

const paidValueSum = (parcels, installmentType, penalty, context) => {
  const total = parcels.reduce((accumulator, parcel) => {
    return accumulator + paidValue(parcel, installmentType, context);
  }, 0);
  return [PENALTY_KINDS.SERVICES, PENALTY_KINDS.MATERIALS].includes(penalty)
    ? total
    : (total / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

const validateParcels = (parcels, installmentType, isService = false) => {
  switch (installmentType) {
    case INSTALLMENT_TYPES.SERVICE.FIXED_PER_PERIOD:
    case INSTALLMENT_TYPES.PECUNIARY.FIXED_PER_PERIOD:
    case INSTALLMENT_TYPES.COMPENSATION_TO_VICTIM.FIXED_PER_PERIOD:
      if (parcels.some(parcel => !parcel.date)) {
        toast.warn('Insira a data em todas as parcelas');
        return false;
      }
      if (parcels.some(parcel => !parcel.value || parcel.value === 0) && !isService) {
        toast.warn('Insira o valor em todas as parcelas');
        return false;
      }
      if (parcels.some(parcel => !parcel.hours || parcel.hours === 0) && isService) {
        toast.warn('Insira as horas em todas as parcelas');
        return false;
      }
      break;

    case INSTALLMENT_TYPES.SERVICE.VARIABLE_PER_PERIOD:
    case INSTALLMENT_TYPES.COMPENSATION_TO_VICTIM.VARIABLE_PER_PERIOD:
    case INSTALLMENT_TYPES.PECUNIARY.VARIABLE_PER_PERIOD:
      if (parcels.some(parcel => !parcel.date)) {
        toast.warn('Insira a data em todas as parcelas');
        return false;
      }
      break;

    case INSTALLMENT_TYPES.SERVICE.PAID_BY_SPECIFIC_DATE:
    case INSTALLMENT_TYPES.COMPENSATION_TO_VICTIM.PAID_BY_SPECIFIC_DATE:
    case INSTALLMENT_TYPES.PECUNIARY.PAID_BY_SPECIFIC_DATE:
      if (parcels.some(parcel => !parcel.date)) {
        toast.warn('Insira a data final');
        return false;
      }
      if (parcels.some(parcel => !parcel.initialDate)) {
        toast.warn('Insira a data do primeiro pagamento');
        return false;
      }
      if (parcels.some(parcel => parcel.initialDate >= parcel.date)) {
        toast.warn('A data final deve ser maior que a data do primeiro pagamento');
        return false;
      }
      if (
        parcels.some(parcel =>
          isService ? !parcel.hours || parcel.hours === 0 : !parcel.value || parcel.value === 0,
        )
      ) {
        toast.warn(isService ? 'Insira o total de horas' : 'Insira o valor total');
        return false;
      }
      break;

    default:
      if (parcels.some(parcel => !parcel.date)) {
        toast.warn('Insira a data em todas as parcelas');
        return false;
      }
      if (!isService && parcels.some(parcel => !parcel.value || parcel.value === 0)) {
        toast.warn('Insira o valor em todas as parcelas');
        return false;
      }
      if (isService && parcels.some(parcel => !parcel.hours || parcel.hours === 0)) {
        toast.warn('Insira as horas em todas as parcelas');
        return false;
      }
      break;
  }

  return true;
};

export {
  parcelsSum,
  parcelsHoursSum,
  parcelsAmountSum,
  orderParcelsByInitialDate,
  parcelsIntegerSum,
  paidValue,
  paidValueSum,
  validateParcels,
};
